// src/components/Patient/Comman/PaymentMemoHTML.js

import { ReceiptText } from "lucide-react";
import React, { useState } from "react";

const PaymentMemoHTML = ({ visit, opdForm, patientReport, index }) => {
  const [showMemo, setShowMemo] = useState(false);

  // --- Handlers ---
  const openMemo = () => setShowMemo(true);
  const closeMemo = () => setShowMemo(false);
  const printMemo = () => window.print();

  // --- Data Getters ---
  const getPatientName = () => opdForm?.userDetails?.name || "N/A";
  const getOpdNumber = () => patientReport?.opdNumber || "N/A";
  const getPaymentDate = () => new Date(visit.date).toLocaleDateString("en-GB");
  const getAmount = () => parseFloat(visit.amount || 0).toFixed(2);
  const getReceiptNumber = () => `${getOpdNumber()}-VISIT-${index + 1}`;

  const MemoContent = () => (
    <div
      id={`payment-memo-content-${index}`}
      style={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        maxWidth: "400px",
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "white",
        border: "1px solid #ccc",
        color: "#333",
        fontSize: "12px",
      }}
    >
      {/* Header */}
      <div style={{ textAlign: "center", borderBottom: "2px solid #333", paddingBottom: "10px", marginBottom: "15px" }}>
        <h1 style={{ fontSize: "18px", margin: 0, fontWeight: "bold" }}>Payment Receipt</h1>
        <p style={{ margin: "5px 0 0 0", fontSize: "14px" }}>Denteex Dental Clinic</p>
      </div>

      {/* Memo Info */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <div>
          <strong>Receipt No:</strong> {getReceiptNumber()}
        </div>
        <div>
          <strong>Date:</strong> {getPaymentDate()}
        </div>
      </div>

      {/* Patient Info */}
      <div style={{ marginBottom: "20px" }}>
        <div>
          <strong>Patient Name:</strong> {getPatientName()}
        </div>
        <div>
          <strong>OPD Number:</strong> {getOpdNumber()}
        </div>
      </div>

      {/* Payment Details */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "25px" }}>
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2", borderBottom: "1px solid #ddd" }}>
            <th style={{ padding: "8px", textAlign: "left" }}>Description</th>
            <th style={{ padding: "8px", textAlign: "right" }}>Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{visit.reason || "Dental Procedure Payment"}</td>
            <td style={{ padding: "8px", textAlign: "right", borderBottom: "1px solid #ddd" }}>{getAmount()}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr style={{ fontWeight: "bold" }}>
            <td style={{ padding: "8px", textAlign: "right" }}>Total Paid:</td>
            <td style={{ padding: "8px", textAlign: "right" }}>₹{getAmount()}</td>
          </tr>
        </tfoot>
      </table>

      {/* Signature */}
      <div style={{ marginTop: "40px", textAlign: "right" }}>
        <div style={{ borderTop: "1px solid #333", width: "150px", display: "inline-block", padding: "5px" }}>
          Authorized Signatory
        </div>
      </div>
    </div>
  );

  return (
    <>
      <button
        type="button"
        onClick={openMemo}
        className="inline-flex items-center gap-2 px-3 py-1.5 text-xs bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors border border-gray-300"
      >
        <ReceiptText size={14} />
        Print Memo
      </button>

      {showMemo && (
        <>
          <style>
            {`
              @media print {
                body * { visibility: hidden; }
                #payment-memo-content-${index}, #payment-memo-content-${index} * { visibility: visible; }
                #payment-memo-content-${index} {
                  position: absolute; left: 0; top: 0; width: 100%; height: 100%;
                  margin: 0; border: none;
                }
                @page { size: auto; margin: 10mm; }
              }
            `}
          </style>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="flex items-center justify-between p-3 border-b bg-gray-50">
                <h3 className="font-semibold text-gray-800">Payment Memo Preview</h3>
                <div className="flex items-center gap-2">
                  <button onClick={printMemo} className="px-3 py-1.5 text-xs bg-blue-600 text-white rounded hover:bg-blue-700">Print</button>
                  <button onClick={closeMemo} className="text-gray-400 hover:text-gray-600">
                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                  </button>
                </div>
              </div>
              <div className="p-4">
                <MemoContent />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PaymentMemoHTML;